export function contracttoBuyandSellLand2026() {
return [   // Release 2025-12-27 09:32:06
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Radiobutton ContractProperty Property with No Residences", 
   isText: false,
   type: "checkbox",
   top: 258.84,
   left: 230.52,
   width: 11.28,
   height: 11.28
}
,
{
   page: 0,
   name: "Radiobutton ContractProperty Property with Residences Residential Addendum Attached", 
   isText: false,
   type: "checkbox",
   top: 280.44,
   left: 150.6,
   width: 11.28,
   height: 11.28
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 304.6,
   left: 447.12,
   width: 125.16,
   height: 11.16
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 410.0,
   left: 115.32,
   width: 419.88,
   height: 11.16
}
,
{
   page: 0,
   name: "Radiobutton Title Joint Tenants", 
   isText: false,
   type: "checkbox",
   top: 424.2,
   left: 279.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton Title Tenants In Common", 
   isText: false,
   type: "checkbox",
   top: 424.2,
   left: 369.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Radiobutton Title Other", 
   isText: false,
   type: "checkbox",
   top: 438.12,
   left: 75.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 0,
   name: "Title Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 436.88,
   left: 120.0,
   width: 444.96,
   height: 11.16
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 476.48,
   left: 113.64,
   width: 424.92,
   height: 11.16
}
,
{
   page: 0,
   name: "Address County", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 508.88,
   left: 428.76,
   width: 140.04,
   height: 11.16
}
,
{
   page: 0,
   name: "Address Legal Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 532.766,
   left: 62.8366,
   width: 506.0744,
   height: 200.5408
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 733.3964,
   left: 126.6,
   width: 424.92,
   height: 13.1236
}
,
{
   page: 1,
   name: "Inclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 118.782,
   left: 67.4185,
   width: 507.3825,
   height: 141.782
}
,
{
   page: 1,
   name: "Inclusions Encumbered", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 329.238,
   left: 73.3094,
   width: 500.1826,
   height: 94.000
}
,
{
   page: 1,
   name: "Radiobutton BuyerAssumeDebtOnEncumberedInclusions Will", 
   isText: false,
   type: "checkbox",
   top: 424.68,
   left: 109.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton BuyerAssumeDebtOnEncumberedInclusions Will Not", 
   isText: false,
   type: "checkbox",
   top: 424.68,
   left: 156.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Leased Items", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 526.912,
   left: 70.6912,
   width: 494.9468,
   height: 112.328
}
,
{
   page: 1,
   name: "Radiobutton BuyerAssumeDebtOnLeasedItems Will", 
   isText: false,
   type: "checkbox",
   top: 640.92,
   left: 107.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton BuyerAssumeDebtOnLeasedItems Will Not", 
   isText: false,
   type: "checkbox",
   top: 640.92,
   left: 154.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox ChecklistItem Solar Power Plan", 
   isText: false,
   type: "checkbox",
   top: 686.52,
   left: 107.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton AssumeSolarPowerPlan Will", 
   isText: false,
   type: "checkbox",
   top: 713.16,
   left: 388.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton AssumeSolarPowerPlan Will Not", 
   isText: false,
   type: "checkbox",
   top: 713.16,
   left: 435.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Exclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 61.192,
   left: 59.5639,
   width: 515.8921,
   height: 100.227
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Deeded Water Rights", 
   isText: false,
   type: "checkbox",
   top: 178.68,
   left: 107.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Deeded Water Rights", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 189.474,
   left: 66.7639,
   width: 507.3831,
   height: 94.000
}
,
{
   page: 2,
   name: "WaterRights Deeded Water Rights Deed", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 282.24,
   left: 347.04,
   width: 159.96,
   height: 11.989
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Other Rights Relating to Water", 
   isText: false,
   type: "checkbox",
   top: 303.48,
   left: 107.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Other Rights Relating To Water", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 329.238,
   left: 76.5822,
   width: 502.8018,
   height: 96.619
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Well Rights", 
   isText: false,
   type: "checkbox",
   top: 428.52,
   left: 107.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Well Permit Number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 508.56,
   left: 162.36,
   width: 405.00,
   height: 11.989
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Water Stock", 
   isText: false,
   type: "checkbox",
   top: 529.08,
   left: 107.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Water Stock", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 540.657,
   left: 69.3821,
   width: 508.6919,
   height: 74.364
}
,
{
   page: 2,
   name: "WaterRights Water and Sewer Taps", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 637.53,
   left: 73.964,
   width: 506.729,
   height: 95.9643
}
,
{
   page: 3,
   name: "Growing Crops", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 121.579,
   left: 62.3499,
   width: 515.2381,
   height: 103.818
}
,
{
   page: 3,
   name: "Time of Day Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 282.12,
   left: 359.52,
   width: 218.28,
   height: 19.80
}
,
{
   page: 3,
   name: "DateAlternative Earnest Money Deadline", 
   fontSize: 9,
   type: "date",
   top: 303.48,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "Alternative Earnest Money Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 302.48,
   left: 359.52,
   width: 218.28,
   height: 19.80
}
,
{
   page: 3,
   name: "DateRecord Title Deadline and Tax Certificate", 
   fontSize: 9,
   type: "date",
   top: 338.08,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "Record Title Deadline and Tax Certificate", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 336.783,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 359.68,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "Record Title Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 359.002,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateOffRecord Title Deadline", 
   fontSize: 9,
   type: "date",
   top: 381.04,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "OffRecord Title Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 381.911,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateOffRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 402.4,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "OffRecord Title Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 402.547,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateTitle Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 424.0,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "Title Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 423.147,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateThird Party Right to PurchaseApprove Deadline", 
   fontSize: 9,
   type: "date",
   top: 445.36,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "Third Party Right to PurchaseApprove Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 444.093,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateAssociation Documents Deadline", 
   fontSize: 9,
   type: "date",
   top: 478.96,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "Association Documents Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 478.166,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateAssociation Documents Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 500.32,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "Association Documents Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 498.839,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateSellers Property Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 533.68,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "Sellers Property Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 532.148,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateLeadBased Paint Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 555.28,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "LeadBased Paint Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 553.093,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateNew Loan Application Deadline", 
   fontSize: 9,
   type: "date",
   top: 588.64,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "New Loan Application Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 585.821,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateNew Loan Terms Deadline", 
   fontSize: 9,
   type: "date",
   top: 610.0,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "New Loan Terms Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 606.766,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateNew Loan Availability Deadline", 
   fontSize: 9,
   type: "date",
   top: 631.6,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "New Loan Availability Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 627.712,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateBuyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 652.96,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "Buyers Credit Information Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 650.621,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateDisapproval of Buyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 674.32,
   left: 296.16,
   width: 61.32,
   height: 16.527
}
,
{
   page: 3,
   name: "Disapproval of Buyers Credit Information Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 672.876,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateExisting Loan Deadline", 
   fontSize: 9,
   type: "date",
   top: 695.92,
   left: 296.16,
   width: 61.32,
   height: 16.5273
}
,
{
   page: 3,
   name: "Existing Loan Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 697.094,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 3,
   name: "DateExisting Loan Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 717.28,
   left: 296.16,
   width: 61.32,
   height: 16.5273
}
,
{
   page: 3,
   name: "Existing Loan Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 715.4213,
   left: 359.52,
   width: 218.28,
   height: 19.8000
}
,
{
   page: 3,
   name: "DateLoan Transfer Approval Deadline", 
   fontSize: 9,
   type: "date",
   top: 738.88,
   left: 296.16,
   width: 61.32,
   height: 16.5273
}
,
{
   page: 3,
   name: "Loan Transfer Approval Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 737.676,
   left: 359.52,
   width: 218.28,
   height: 19.800
}
,
{
   page: 4,
   name: "DateSeller or Private Financing Deadline", 
   fontSize: 9,
   type: "date",
   top: 72.84,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Seller or Private Financing Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 72.84,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateAppraisal Deadline", 
   fontSize: 9,
   type: "date",
   top: 107.2,
   left: 296.16,
   width: 61.32,
   height: 16.9
}
,
{
   page: 4,
   name: "Appraisal Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 105.764,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateAppraisal Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 128.56,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Appraisal Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 126.673,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateAppraisal Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 150.16,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Appraisal Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 148.928,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Deadline", 
   fontSize: 9,
   type: "date",
   top: 183.52,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "New ILC or New Survey Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 182.964,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 205.12,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "New ILC or New Survey Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 203.565,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 226.48,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "New ILC or New Survey Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 224.546,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateWater Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 259.84,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Water Rights Examination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 259.237,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateMineral Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 281.44,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Mineral Rights Examination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 280.147,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateInspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 302.8,
   left: 296.16,
   width: 61.32,
   height: 16.9
}
,
{
   page: 4,
   name: "Inspection Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 301.914,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateInspection Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 324.16,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Inspection Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 323.347,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateInspection Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 345.76,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Inspection Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 344.329,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateProperty Insurance Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 367.12,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Property Insurance Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 365.583,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateDue Diligence Documents Delivery Deadline", 
   fontSize: 9,
   type: "date",
   top: 388.48,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Due Diligence Documents Delivery Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 386.911,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateDue Diligence Documents Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 410.08,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Due Diligence Documents Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 408.784,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateDue Diligence Documents Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 431.44,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Due Diligence Documents Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 430.693,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateEnvironmental Inspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 453.04,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Environmental Inspection Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 452.566,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateADA Evaluation Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 474.4,
   left: 296.16,
   width: 61.32,
   height: 16.9
}
,
{
   page: 4,
   name: "ADA Evaluation Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 473.857,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateConditional Sale Deadline", 
   fontSize: 9,
   type: "date",
   top: 495.76,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Conditional Sale Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 494.766,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateLeadBased Paint Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 517.36,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "LeadBased Paint Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 516.021,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateEstoppel Statements Deadline", 
   fontSize: 9,
   type: "date",
   top: 538.72,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Estoppel Statements Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 537.384,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateEstoppel Statements Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 560.08,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Estoppel Statements Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 558.984,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DateClosing Date", 
   fontSize: 9,
   type: "date",
   top: 593.68,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Closing Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 593.094,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "DatePossession Date", 
   fontSize: 9,
   type: "date",
   top: 615.04,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Possession Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 614.421,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "Possession Time", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 636.494,
   left: 359.52,
   width: 218.28,
   height: 26.379
}
,
{
   page: 4,
   name: "DateAcceptance Deadline Date", 
   fontSize: 9,
   type: "date",
   top: 668.32,
   left: 296.16,
   width: 61.32,
   height: 16.90
}
,
{
   page: 4,
   name: "Acceptance Deadline Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 667.639,
   left: 359.52,
   width: 218.28,
   height: 18.978
}
,
{
   page: 4,
   name: "Acceptance Deadline Time", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 689.276,
   left: 359.52,
   width: 218.28,
   height: 18.9775
}
,
{
   page: 4,
   name: "Deadlines Extra Row Item 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 709.6849,
   left: 43.8,
   width: 21.24,
   height: 17.5918
}
,
{
   page: 4,
   name: "Deadlines Extra Row Reference 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 709.68,
   left: 67.1291,
   width: 26.5960,
   height: 20.40
}
,
{
   page: 4,
   name: "Deadlines Extra Row Title 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 710.28,
   left: 94.08,
   width: 200.04,
   height: 19.80
}
,
{
   page: 4,
   name: "Date Deadlines Extra Row 1", 
   fontSize: 9,
   type: "date",
   top: 712.28,
   left: 296.16,
   width: 61.32,
   height: 16.8995
}
,
{
   page: 4,
   name: "Deadlines Extra Row 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 710.28,
   left: 359.52,
   width: 218.28,
   height: 18.9775
}
,
{
   page: 4,
   name: "Deadlines Extra Row Item 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 732.6058,
   left: 43.5887,
   width: 21.7012,
   height: 21.1776
}
,
{
   page: 4,
   name: "Deadlines Extra Row Reference 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 731.04,
   left: 67.1291,
   width: 25.8709,
   height: 22.80
}
,
{
   page: 4,
   name: "Deadlines Extra Row Title 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 731.64,
   left: 94.08,
   width: 200.04,
   height: 22.20
}
,
{
   page: 4,
   name: "Date Deadlines Extra Row 2", 
   fontSize: 9,
   type: "date",
   top: 733.64,
   left: 296.16,
   width: 61.32,
   height: 16.8995
}
,
{
   page: 4,
   name: "Deadlines Extra Row 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 731.64,
   left: 359.52,
   width: 218.28,
   height: 18.9775
}
,
{
   page: 5,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will Not", 
   isText: false,
   type: "checkbox",
   top: 249.48,
   left: 82.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will", 
   isText: false,
   type: "checkbox",
   top: 249.48,
   left: 129.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 5,
   name: "Amount Purchase Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 330.6,
   left: 311.707,
   width: 89.213,
   height: 13.32
}
,
{
   page: 5,
   name: "Amount Earnest Money", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 345.24,
   left: 418.095,
   width: 82.665,
   height: 12.258
}
,
{
   page: 5,
   name: "Amount New Loan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 359.64,
   left: 418.095,
   width: 82.665,
   height: 12.258
}
,
{
   page: 5,
   name: "Amount Assumption Balance", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 374.28,
   left: 418.095,
   width: 82.665,
   height: 12.258
}
,
{
   page: 5,
   name: "Amount Private Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 388.92,
   left: 418.095,
   width: 82.665,
   height: 12.258
}
,
{
   page: 5,
   name: "Amount Seller Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 403.32,
   left: 418.095,
   width: 82.665,
   height: 12.258
}
,
{
   page: 5,
   name: "Purchase Item 7 Reference", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 417.96,
   left: 127.2,
   width: 52.92,
   height: 12.12
}
,
{
   page: 5,
   name: "Purchase 7 Description", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 417.96,
   left: 181.68,
   width: 117.24,
   height: 12.12
}
,
{
   page: 5,
   name: "Amount Purchase 7 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 417.96,
   left: 300.48,
   width: 100.44,
   height: 12.12
}
,
{
   page: 5,
   name: "Amount Purchase 7 Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 417.96,
   left: 418.095,
   width: 82.665,
   height: 12.258
}
,
{
   page: 5,
   name: "Purchase 8 Reference", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 431.4,
   left: 127.2,
   width: 52.92,
   height: 12.12
}
,
{
   page: 5,
   name: "Purchase 8 Description", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 431.4,
   left: 181.68,
   width: 117.24,
   height: 12.12
}
,
{
   page: 5,
   name: "Amount Purchase 8 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 431.4,
   left: 300.48,
   width: 100.44,
   height: 12.12
}
,
{
   page: 5,
   name: "Amount Purchase 8 Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 431.4,
   left: 418.095,
   width: 82.665,
   height: 12.258
}
,
{
   page: 5,
   name: "Amount Cash at Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 444.84,
   left: 418.095,
   width: 82.665,
   height: 12.258
}
,
{
   page: 5,
   name: "CALCULATE Amount Purchase Price PLUS Amount Purchase 7 Debit PLUS Amount Purchase 8 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459.48,
   left: 312.53,
   width: 88.39,
   height: 13.32
}
,
{
   page: 5,
   name: "CALCULATE Amount Earnest Money PLUS Amount New Loan PLUS Amount Assumption Balance PLUS Amount Private Financing PLUS Amount Seller Financing PLUS Amount Purchase 7 Credit PLUS Amount Purchase 8 Credit PLUS Amount Cash at Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459.48,
   left: 418.095,
   width: 82.665,
   height: 12.258
}
,
{
   page: 5,
   name: "Amount Seller Concession", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 477.05,
   left: 351.24,
   width: 84.96,
   height: 12.91
}
,
{
   page: 5,
   name: "Earnest Money Form", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 569.304,
   left: 72.6549,
   width: 479.7941,
   height: 12.953
}
,
{
   page: 5,
   name: "Earnest Money Holder", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 582.562,
   left: 197.637,
   width: 305.439,
   height: 12.131
}
,
{
   page: 6,
   name: "Radiobutton AvailableFunds Does have funds", 
   isText: false,
   type: "checkbox",
   top: 277.84,
   left: 427.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AvailableFunds Does not have funds", 
   isText: false,
   type: "checkbox",
   top: 276.84,
   left: 471.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox Group Loan Conventional", 
   isText: false,
   type: "checkbox",
   top: 397.8,
   left: 86.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox Group Loan Other", 
   isText: false,
   type: "checkbox",
   top: 396.84,
   left: 169.8,
   width: 11.28,
   height: 11.28
}
,
{
   page: 6,
   name: "Loan Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 395.28,
   left: 216.48,
   width: 320.04,
   height: 12.36
}
,
{
   page: 6,
   name: "Amount Assumption At", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 427.663,
   left: 295.252,
   width: 80.916,
   height: 12.953
}
,
{
   page: 6,
   name: "Assumption Per", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 427.44,
   left: 392.88,
   width: 129.96,
   height: 12.36
}
,
{
   page: 6,
   name: "Assumption Rate", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 440.64,
   left: 251.4,
   width: 60.0,
   height: 12.36
}
,
{
   page: 6,
   name: "Checkbox Group AssumptionEscrow Real Estate Taxes", 
   isText: false,
   type: "checkbox",
   top: 470.52,
   left: 73.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox Group AssumptionEscrow Property Insurance Premium", 
   isText: false,
   type: "checkbox",
   top: 470.52,
   left: 172.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Checkbox Group AssumptionEscrow Other", 
   isText: false,
   type: "checkbox",
   top: 469.56,
   left: 349.8,
   width: 11.28,
   height: 11.28
}
,
{
   page: 6,
   name: "AssumptionEscrow Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 469.0,
   left: 366.96,
   width: 195.00,
   height: 12.36
}
,
{
   page: 6,
   name: "Amount Assumption Loan Transfer Fee Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 481.68,
   left: 310.56,
   width: 80.04,
   height: 12.36
}
,
{
   page: 6,
   name: "Percent Assumption Loan Interest Rate Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 494.88,
   left: 152.88,
   width: 50.04,
   height: 12.36
}
,
{
   page: 6,
   name: "Amount Assumption New Payment Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 494.88,
   left: 422.76,
   width: 65.04,
   height: 12.36
}
,
{
   page: 6,
   name: "Assumption New Payment Per", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 508.08,
   left: 72.96,
   width: 105.00,
   height: 12.36
}
,
{
   page: 6,
   name: "Amount Assumption Cash At Closing Increase Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 534.48,
   left: 176.16,
   width: 75.00,
   height: 12.36
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will", 
   isText: false,
   type: "checkbox",
   top: 563.4,
   left: 115.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will Not", 
   isText: false,
   type: "checkbox",
   top: 563.4,
   left: 157.32,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseDelivery On or Before Loan Transfer Approval Deadline", 
   isText: false,
   type: "checkbox",
   top: 576.6,
   left: 285,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton AssumptionReleaseDelivery At Closing", 
   isText: false,
   type: "checkbox",
   top: 576.6,
   left: 506.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Assumption Release of Liability Paid By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 600.104,
   left: 71.3458,
   width: 233.0652,
   height: 13.775
}
,
{
   page: 6,
   name: "Amount Assumption Release of Liability Max Cost", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 600.72,
   left: 428.28,
   width: 80.04,
   height: 12.36
}
,
{
   page: 6,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Buyer", 
   isText: false,
   type: "checkbox",
   top: 732.6,
   left: 79.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Seller", 
   isText: false,
   type: "checkbox",
   top: 732.6,
   left: 129,
   width: 10.08,
   height: 10.08
}
,
{
   page: 6,
   name: "Seller Financing Deliver Financing Documents Number Days before Seller or Private Financing Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 730.08,
   left: 516.12,
   width: 54.96,
   height: 12.36
}
,
{
   page: 8,
   name: "Radiobutton WhoPaysAppraisal Buyer", 
   isText: false,
   type: "checkbox",
   top: 275.4,
   left: 73.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 8,
   name: "Radiobutton WhoPaysAppraisal Seller", 
   isText: false,
   type: "checkbox",
   top: 275.4,
   left: 123.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoSelectsTitleCompany Seller", 
   isText: false,
   type: "checkbox",
   top: 343.8,
   left: 107.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Checkbox Abstract of Title", 
   isText: false,
   type: "checkbox",
   top: 381.72,
   left: 208.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoSelectsTitleCompany Buyer", 
   isText: false,
   type: "checkbox",
   top: 410.04,
   left: 109.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton TitleContainsOEC Will", 
   isText: false,
   type: "checkbox",
   top: 476.04,
   left: 370.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton TitleContainsOEC Will Not", 
   isText: false,
   type: "checkbox",
   top: 476.04,
   left: 415.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Buyer", 
   isText: false,
   type: "checkbox",
   top: 533.64,
   left: 239.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Seller", 
   isText: false,
   type: "checkbox",
   top: 533.64,
   left: 291.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Split", 
   isText: false,
   type: "checkbox",
   top: 533.64,
   left: 342.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysOEC Other", 
   isText: false,
   type: "checkbox",
   top: 546.12,
   left: 77.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 9,
   name: "WhoPaysOEC Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 544.32,
   left: 121.2,
   width: 440.04,
   height: 11.64
}
,
{
   page: 10,
   name: "Website Metro District", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 527.28,
   left: 85.44,
   width: 414.00,
   height: 12.60
}
,
{
   page: 10,
   name: "Radiobutton WhoPaysTaxCertificate Seller", 
   isText: false,
   type: "checkbox",
   top: 544.68,
   left: 275.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton WhoPaysTaxCertificate Buyer", 
   isText: false,
   type: "checkbox",
   top: 544.68,
   left: 324.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Checkbox Group ILCorSurvey New ILC", 
   isText: false,
   type: "checkbox",
   top: 617.88,
   left: 90.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Checkbox Group ILCorSurvey New Survey", 
   isText: false,
   type: "checkbox",
   top: 631.56,
   left: 90.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Survey Form", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 628.56,
   left: 217.8,
   width: 349.92,
   height: 12.84
}
,
{
   page: 11,
   name: "Radiobutton WhoOrdersNew_ILC_OrSurvey Seller", 
   isText: false,
   type: "checkbox",
   top: 662.28,
   left: 277.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton WhoOrdersNew_ILC_OrSurvey Buyer", 
   isText: false,
   type: "checkbox",
   top: 662.28,
   left: 326.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton WhoPaysNewILCorSurvey Seller", 
   isText: false,
   type: "checkbox",
   top: 718.2,
   left: 133.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 11,
   name: "Radiobutton WhoPaysNewILCorSurvey Buyer", 
   isText: false,
   type: "checkbox",
   top: 718.2,
   left: 182.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "WhoPaysNewILCorSurvey Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 61.2,
   left: 247.92,
   width: 324.96,
   height: 12.36
}
,
{
   page: 13,
   name: "Occupancy Agreements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.247,
   left: 91.6368,
   width: 483.9062,
   height: 84.505
}
,
{
   page: 13,
   name: "Checkbox ChecklistItem All contracts relating to the operation maintenance and management of the Property", 
   isText: false,
   type: "checkbox",
   top: 527.88,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Checkbox ChecklistItem Property tax bills for the last number of years", 
   isText: false,
   type: "checkbox",
   top: 542.52,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Number of Years of Property Tax Bills", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 540.48,
   left: 281.76,
   width: 64.92,
   height: 11.88
}
,
{
   page: 13,
   name: "Checkbox ChecklistItem As built construction plans to the Property and the tenant improvements including architectural electrical mechanical and structural systems engineering reports permanent Certificates of Occupancy", 
   isText: false,
   type: "checkbox",
   top: 557.16,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Checkbox ChecklistItem A list of all Inclusions to be conveyed to Buyer", 
   isText: false,
   type: "checkbox",
   top: 597.24,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Checkbox ChecklistItem Operating statements for the past number of years", 
   isText: false,
   type: "checkbox",
   top: 611.88,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Number of Years Operating statements", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 609.84,
   left: 299.76,
   width: 64.92,
   height: 11.88
}
,
{
   page: 13,
   name: "Checkbox ChecklistItem A rent roll accurate and correct to the date of this Contract", 
   isText: false,
   type: "checkbox",
   top: 626.52,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Checkbox ChecklistItem A schedule of any tenant improvement work Seller is obligated to complete but has not yet completed", 
   isText: false,
   type: "checkbox",
   top: 641.16,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Checkbox ChecklistItem All insurance policies pertaining to the Property and copies of any claims which have been made for the past number of years", 
   isText: false,
   type: "checkbox",
   top: 668.52,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Number of Years copies of insurance policies", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 679.2,
   left: 138.72,
   width: 64.92,
   height: 11.88
}
,
{
   page: 13,
   name: "Checkbox ChecklistItem Soils reports surveys and engineering reports or data pertaining to the Property if not delivered earlier", 
   isText: false,
   type: "checkbox",
   top: 695.64,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 13,
   name: "Checkbox ChecklistItem Any and all existing documentation and reports regarding Phase I and II environmental reports", 
   isText: false,
   type: "checkbox",
   top: 723,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Any Americans with Disabilities Act reports studies or surveys concerning the compliance of the Property with said Act", 
   isText: false,
   type: "checkbox",
   top: 77.88,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem All permits licenses and other building or use authorizations issued by any governmental authority", 
   isText: false,
   type: "checkbox",
   top: 105,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Other Documents", 
   isText: false,
   type: "checkbox",
   top: 145.08,
   left: 149.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "ChecklistItem Other Documents", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 156.437,
   left: 97.5277,
   width: 469.9243,
   height: 65.589
}
,
{
   page: 14,
   name: "Radiobutton WhoProvidesPhaseI_EnvironmentalSiteAssessment Seller", 
   isText: false,
   type: "checkbox",
   top: 506.28,
   left: 253.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Radiobutton WhoProvidesPhaseI_EnvironmentalSiteAssessment Buyer", 
   isText: false,
   type: "checkbox",
   top: 506.28,
   left: 301.32,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Due Diligence Environmental Extra", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 529.68,
   left: 241.56,
   width: 330.00,
   height: 11.88
}
,
{
   page: 14,
   name: "Radiobutton WhoPaysEnvironmentalInspection Seller", 
   isText: false,
   type: "checkbox",
   top: 544.2,
   left: 152.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Radiobutton WhoPaysEnvironmentalInspection Buyer", 
   isText: false,
   type: "checkbox",
   top: 544.2,
   left: 203.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "DueDiligenceEnvironmental Extend Environmental Inspection Termination Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 567.6,
   left: 368.16,
   width: 130.08,
   height: 11.88
}
,
{
   page: 14,
   name: "Radiobutton WhoPaysPhaseII_EnvironmentalInspection Seller", 
   isText: false,
   type: "checkbox",
   top: 594.84,
   left: 473.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Radiobutton WhoPaysPhaseII_EnvironmentalInspection Buyer", 
   isText: false,
   type: "checkbox",
   top: 594.84,
   left: 521.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Conditional Sale of Property Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 61.2,
   left: 244.32,
   width: 324.96,
   height: 12.36
}
,
{
   page: 15,
   name: "Radiobutton AcknowledgeReceiptOfSPD Does", 
   isText: false,
   type: "checkbox",
   top: 146.04,
   left: 105.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton AcknowledgeReceiptOfSPD Does Not", 
   isText: false,
   type: "checkbox",
   top: 146.04,
   left: 152.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Checkbox Well There is no well", 
   isText: false,
   type: "checkbox",
   top: 172.68,
   left: 73.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton AcknowledgeReceiptWellPermit Does", 
   isText: false,
   type: "checkbox",
   top: 172.68,
   left: 199.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton AcknowledgeReceiptWellPermit Does Not", 
   isText: false,
   type: "checkbox",
   top: 172.68,
   left: 243.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton ClosingInstructionsExecutedWithContract Are", 
   isText: false,
   type: "checkbox",
   top: 723,
   left: 415.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton ClosingInstructionsExecutedWithContract Are Not", 
   isText: false,
   type: "checkbox",
   top: 723,
   left: 455.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Closing Designated By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 74.4,
   left: 334.8,
   width: 235.08,
   height: 12.36
}
,
{
   page: 16,
   name: "Radiobutton DeedType Special Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 184.2,
   left: 62.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton DeedType General Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 184.2,
   left: 207.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton DeedType Bargain And Sale Deed", 
   isText: false,
   type: "checkbox",
   top: 184.2,
   left: 320.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton DeedType Quit Claim Deed", 
   isText: false,
   type: "checkbox",
   top: 184.2,
   left: 430.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton DeedType Personal Representatives Deed", 
   isText: false,
   type: "checkbox",
   top: 198.12,
   left: 62.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton DeedType Deed Other", 
   isText: false,
   type: "checkbox",
   top: 198.12,
   left: 207.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "DeedType Deed Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 195.6,
   left: 223.68,
   width: 315.00,
   height: 12.36
}
,
{
   page: 16,
   name: "Radiobutton ClosingServicesFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 393.72,
   left: 93.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ClosingServicesFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 393.72,
   left: 151.08,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ClosingServicesFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 393.72,
   left: 207,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ClosingServicesFeePaidBy Other", 
   isText: false,
   type: "checkbox",
   top: 393.72,
   left: 413.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "ClosingServicesFeePaidBy Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 391.2,
   left: 457.68,
   width: 109.92,
   height: 12.36
}
,
{
   page: 16,
   name: "Radiobutton RecordChangeFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 473.4,
   left: 192.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton RecordChangeFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 473.4,
   left: 255.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton RecordChangeFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 473.4,
   left: 311.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton RecordChangeFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 473.4,
   left: 518.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 511.08,
   left: 192.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 511.08,
   left: 255.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 511.08,
   left: 311.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 511.08,
   left: 518.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton OtherFeesPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 537,
   left: 192.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton OtherFeesPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 537,
   left: 255.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton OtherFeesPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 537,
   left: 311.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton OtherFeesPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 537,
   left: 518.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton LocalTransferTaxPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 562.92,
   left: 192.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton LocalTransferTaxPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 562.92,
   left: 255.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton LocalTransferTaxPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 562.92,
   left: 311.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton LocalTransferTaxPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 562.92,
   left: 518.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton SalesAndUseTaxPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 589.08,
   left: 192.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton SalesAndUseTaxPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 589.08,
   left: 255.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton SalesAndUseTaxPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 589.08,
   left: 311.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton SalesAndUseTaxPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 589.08,
   left: 518.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton PrivateTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 626.52,
   left: 192.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton PrivateTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 626.52,
   left: 255.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton PrivateTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 626.52,
   left: 311.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton PrivateTransferFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 626.52,
   left: 518.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Amount Water Transfer Fee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 652.32,
   left: 78,
   width: 75,
   height: 12.36
}
,
{
   page: 16,
   name: "Checkbox Group WaterTransferFees Water DistrictMunicipality", 
   isText: false,
   type: "checkbox",
   top: 668.52,
   left: 73.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Checkbox Group WaterTransferFees Water Stock", 
   isText: false,
   type: "checkbox",
   top: 668.52,
   left: 237.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Checkbox Group WaterTransferFees Augmentation Membership", 
   isText: false,
   type: "checkbox",
   top: 682.44,
   left: 73.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Checkbox Group WaterTransferFees Small Domestic Water Company", 
   isText: false,
   type: "checkbox",
   top: 682.44,
   left: 237.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Checkbox Group WaterTransferFees Other", 
   isText: false,
   type: "checkbox",
   top: 683.26,
   left: 407.924,
   width: 10.080,
   height: 10.0801
}
,
{
   page: 16,
   name: "WaterTransferFees Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 679.92,
   left: 424.2,
   width: 135.0,
   height: 12.36
}
,
{
   page: 16,
   name: "Radiobutton WaterTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 710.04,
   left: 192.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton WaterTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 710.04,
   left: 255.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton WaterTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 710.04,
   left: 311.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton WaterTransferFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 710.04,
   left: 518.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton UtilityTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 742.92,
   left: 192.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton UtilityTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 742.92,
   left: 255.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton UtilityTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 742.92,
   left: 311.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton UtilityTransferFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 742.92,
   left: 518.04,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Checkbox IS a foreign person", 
   isText: false,
   type: "checkbox",
   top: 101.16,
   left: 107.88,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton Taxes Taxes for the Calendar Year Immediately Preceding Closing", 
   isText: false,
   type: "checkbox",
   top: 279.96,
   left: 77.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton Taxes Most Recent Mill Levy and Most Recent Assessed or Actual Valuation per the county assessor", 
   isText: false,
   type: "checkbox",
   top: 293.64,
   left: 77.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton Taxes Other", 
   isText: false,
   type: "checkbox",
   top: 307.56,
   left: 77.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Taxes Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 305.16,
   left: 121.2,
   width: 429.96,
   height: 12.36
}
,
{
   page: 17,
   name: "Radiobutton Rents Actually Received", 
   isText: false,
   type: "checkbox",
   top: 327.24,
   left: 207,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton Rents Accrued", 
   isText: false,
   type: "checkbox",
   top: 327.24,
   left: 334.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Other Prorations", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 382.911,
   left: 70.6912,
   width: 508.5788,
   height: 47.495
}
,
{
   page: 17,
   name: "Radiobutton AssociationAssessmentsObligation Buyer", 
   isText: false,
   type: "checkbox",
   top: 512.76,
   left: 132.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton AssociationAssessmentsObligation Seller", 
   isText: false,
   type: "checkbox",
   top: 512.76,
   left: 182.52,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Special Assessments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 564.28,
   left: 72.96,
   width: 495.00,
   height: 12.36
}
,
{
   page: 17,
   name: "Amount Possession Per Day", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 635.28,
   left: 439.32,
   width: 65.04,
   height: 12.36
}
,
{
   page: 18,
   name: "Checkbox Specific Performance", 
   isText: false,
   type: "checkbox",
   top: 629.4,
   left: 109.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 20,
   name: "Electronic Notice", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 95.76,
   left: 72.96,
   width: 450.00,
   height: 10.68
}
,
{
   page: 20,
   name: "Checkbox PaysBuyerBrokerage Seller", 
   isText: false,
   type: "checkbox",
   top: 327.583,
   left: 87.7095,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 20,
   name: "Percent Seller Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 324.64,
   left: 102.015,
   width: 35.040,
   height: 13.407
}
,
{
   page: 20,
   name: "Amount Seller Pays Buyers Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 324.64,
   left: 255.855,
   width: 75.000,
   height: 13.407
}
,
{
   page: 20,
   name: "Checkbox PaysBuyerBrokerage Buyer", 
   isText: false,
   type: "checkbox",
   top: 373.093,
   left: 87.7095,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 20,
   name: "Percent Buyer Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 370.48,
   left: 104.535,
   width: 34.920,
   height: 13.407
}
,
{
   page: 20,
   name: "Amount Buyer Pays Buyers Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 370.48,
   left: 258.375,
   width: 75.000,
   height: 13.407
}
,
{
   page: 20,
   name: "Checkbox PaysBuyerBrokerage Sellers Brokerage", 
   isText: false,
   type: "checkbox",
   top: 418.911,
   left: 87.7095,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 20,
   name: "Percent Seller Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 415.88,
   left: 102.015,
   width: 35.040,
   height: 13.407
}
,
{
   page: 20,
   name: "Amount Sellers Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 415.88,
   left: 255.855,
   width: 75.000,
   height: 13.407
}
,
{
   page: 20,
   name: "Additional Provisions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 492.875,
   left: 41.8911,
   width: 540.7649,
   height: 268.7646
}
,
{
   page: 21,
   name: "Documents Not Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 468.657,
   left: 57.6003,
   width: 495.6017,
   height: 69.782
}
,
{
   page: 21,
   name: "Additional Provisions 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 61.528,
   left: 52.3639,
   width: 499.5291,
   height: 313.928
}
,
{
   page: 21,
   name: "Documents Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 401.893,
   left: 58.9093,
   width: 494.2927,
   height: 56.691
}
,
{
   page: 21,
   name: "Buyer 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 576.64,
   left: 137.76,
   width: 435.00,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 614.68,
   left: 137.76,
   width: 435.00,
   height: 14.04
}
,
{
   page: 21,
   name: "Buyer 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 629.44,
   left: 137.76,
   width: 170.04,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 629.44,
   left: 450.24,
   width: 120.00,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 644.44,
   left: 137.76,
   width: 435.00,
   height: 13.80
}
,
{
   page: 21,
   name: "Buyer 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 666.88,
   left: 137.76,
   width: 435.00,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 705.04,
   left: 137.76,
   width: 435.00,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 719.92,
   left: 137.76,
   width: 170.04,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 719.92,
   left: 450.24,
   width: 120.00,
   height: 14.16
}
,
{
   page: 21,
   name: "Buyer 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 734.92,
   left: 137.76,
   width: 435.00,
   height: 13.80
}
,
{
   page: 22,
   name: "Buyer 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.2,
   left: 137.76,
   width: 435.00,
   height: 13.338
}
,
{
   page: 22,
   name: "Buyer 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 97.4,
   left: 137.76,
   width: 435.00,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 168.4,
   left: 138.582,
   width: 435.000,
   height: 13.338
}
,
{
   page: 22,
   name: "Sellers Signature 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 206.56,
   left: 137.76,
   width: 429.96,
   height: 13.338
}
,
{
   page: 22,
   name: "Sellers Signature 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 221.44,
   left: 137.76,
   width: 170.04,
   height: 13.338
}
,
{
   page: 22,
   name: "Fax No_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 221.44,
   left: 450.24,
   width: 120.00,
   height: 13.338
}
,
{
   page: 22,
   name: "Email Address_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 236.44,
   left: 137.76,
   width: 435.00,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 264.4,
   left: 137.76,
   width: 435.00,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 302.44,
   left: 137.76,
   width: 429.96,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 317.2,
   left: 137.76,
   width: 170.04,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 317.2,
   left: 450.24,
   width: 120.00,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 332.2,
   left: 137.76,
   width: 435.00,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 360.16,
   left: 137.76,
   width: 435.00,
   height: 13.338
}
,
{
   page: 22,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 414.64,
   left: 137.76,
   width: 435.00,
   height: 13.338
}
,
{
   page: 22,
   name: "Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does", 
   isText: false,
   type: "checkbox",
   top: 608.52,
   left: 83.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 22,
   name: "Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does Not", 
   isText: false,
   type: "checkbox",
   top: 608.52,
   left: 128.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 22,
   name: "Radiobutton BuyerBrokerRelationship Buyers Agent", 
   isText: false,
   type: "checkbox",
   top: 699.96,
   left: 50.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 22,
   name: "Radiobutton BuyerBrokerRelationship TransactionBroker", 
   isText: false,
   type: "checkbox",
   top: 719.16,
   left: 50.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 22,
   name: "Radiobutton BuyerBrokerRelationship Customer", 
   isText: false,
   type: "checkbox",
   top: 738.36,
   left: 50.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Buyer Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 157.48,
   left: 173.76,
   width: 378.12,
   height: 13.233
}
,
{
   page: 23,
   name: "Buyer Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 175.36,
   left: 173.76,
   width: 378.12,
   height: 13.233
}
,
{
   page: 23,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 192.0,
   left: 173.76,
   width: 378.12,
   height: 13.233
}
,
{
   page: 23,
   name: "Buyer Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 210.52,
   left: 173.76,
   width: 378.12,
   height: 13.233
}
,
{
   page: 23,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 230.092,
   left: 178.692,
   width: 174.873,
   height: 13.233
}
,
{
   page: 23,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 229.84,
   left: 359.04,
   width: 96.00,
   height: 13.233
}
,
{
   page: 23,
   name: "Signature Buyer CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 270.638,
   left: 178.692,
   width: 174.873,
   height: 13.232
}
,
{
   page: 23,
   name: "Date Signature Buyer CoAgent", 
   fontSize: 9,
   type: "date",
   top: 270.88,
   left: 359.695,
   width: 96.000,
   height: 13.233
}
,
{
   page: 23,
   name: "Buyer Brokerage Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 309.6,
   left: 173.76,
   width: 378.12,
   height: 13.233
}
,
{
   page: 23,
   name: "Buyer Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 328.36,
   left: 173.76,
   width: 378.12,
   height: 13.233
}
,
{
   page: 23,
   name: "Buyer Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 346.12,
   left: 173.76,
   width: 378.12,
   height: 13.233
}
,
{
   page: 23,
   name: "Buyer Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 363.88,
   left: 173.04,
   width: 378.84,
   height: 13.233
}
,
{
   page: 23,
   name: "Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does", 
   isText: false,
   type: "checkbox",
   top: 452.28,
   left: 83.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does Not", 
   isText: false,
   type: "checkbox",
   top: 452.28,
   left: 128.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Radiobutton SellerBrokerRelationship Sellers Agent", 
   isText: false,
   type: "checkbox",
   top: 540.84,
   left: 50.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Radiobutton SellerBrokerRelationship Transaction Broker", 
   isText: false,
   type: "checkbox",
   top: 556.92,
   left: 50.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Radiobutton SellerBrokerRelationship Customer", 
   isText: false,
   type: "checkbox",
   top: 573.24,
   left: 50.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Checkbox SellerBrokerageFirmPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 615.96,
   left: 50.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Checkbox SellerBrokerageFirmPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 632.04,
   left: 50.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Checkbox SellerBrokerageFirmPaidBy Other", 
   isText: false,
   type: "checkbox",
   top: 648.36,
   left: 50.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "SellerBrokerageFirmPaidBy Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 645.16,
   left: 95.6224,
   width: 464.9996,
   height: 12.578
}
,
{
   page: 23,
   name: "Seller Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 724.04,
   left: 174.48,
   width: 364.92,
   height: 12.5781
}
,
{
   page: 24,
   name: "Seller Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.2,
   left: 174.48,
   width: 364.92,
   height: 13.887
}
,
{
   page: 24,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 64.08,
   left: 174.48,
   width: 364.92,
   height: 13.887
}
,
{
   page: 24,
   name: "Seller Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 81.36,
   left: 175.135,
   width: 364.920,
   height: 13.887
}
,
{
   page: 24,
   name: "Signature Broker Seller", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 106.728,
   left: 174.11,
   width: 174.873,
   height: 13.887
}
,
{
   page: 24,
   name: "Date Signature Broker Seller", 
   fontSize: 9,
   type: "date",
   top: 106.728,
   left: 354.48,
   width: 96.00,
   height: 13.887
}
,
{
   page: 24,
   name: "Signature CoAgent Seller", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 148.31,
   left: 174.764,
   width: 176.182,
   height: 13.233
}
,
{
   page: 24,
   name: "Date Signature CoAgent Seller", 
   fontSize: 9,
   type: "date",
   top: 148.24,
   left: 354.48,
   width: 96.00,
   height: 13.887
}
,
{
   page: 24,
   name: "Seller Brokerage Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 186.96,
   left: 169.2,
   width: 382.68,
   height: 13.887
}
,
{
   page: 24,
   name: "Seller Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 204.72,
   left: 169.2,
   width: 382.68,
   height: 13.887
}
,
{
   page: 24,
   name: "Seller Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 222.48,
   left: 169.2,
   width: 382.68,
   height: 13.887
}
,
{
   page: 24,
   name: "Seller Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 240.24,
   left: 169.135,
   width: 383.400,
   height: 13.887
}
] }
